<template>
  <div>
    <h2 class="dadosFalecimBox_header">
      Funerária
    </h2>
    <form
      class="px-2 pt-2"
      name="formFuneraria"
      novalidate
      @submit.prevent="searchFunerarias">
      <div class="row align-items-end">
        <div class="col-12">
          <div class="form-group">
            <label
              class="d-block label"
              for="convenioSim">Possui convênio funerária</label>

            <span class="custom-control custom-radio custom-control-inline">
              <input
                id="convenioSim"
                v-model="convenio_funeraria"
                type="radio"
                name="convenioSim"
                :value="true"
                class="custom-control-input"
                @change="changed"
                @keyup.enter="() => { convenio_funeraria = true; changed(); }">
              <label
                class="custom-control-label"
                for="convenioSim">Sim</label>
            </span>

            <span class="custom-control custom-radio custom-control-inline">
              <input
                id="convenioNao"
                v-model="convenio_funeraria"
                type="radio"
                name="convenioNao"
                :value="false"
                class="custom-control-input"
                @change="changed"
                @keyup.enter="() => { convenio_funeraria = false; changed(); }">
              <label
                class="custom-control-label"
                for="convenioNao">Não</label>
            </span>
          </div>
        </div>
      </div>
      <div class="row align-items-end">
        <div v-if="convenio_funeraria === true"
             class="col-6">
          <div class="form-group">
            <label
              class="label"
              for="numero_declaracao_funeraria">Número Declaração Funerária</label>
            <input
              id="numero_declaracao_funeraria"
              v-model="localData.numero_declaracao_funeraria"
              class="form-control form-control-sm"
              name="numero_declaracao_funeraria"
              placeholder="00000000000000000"
              type="text"
              @change="changeNumDeclrFun">
          </div>
        </div>
      </div>
    </form>

    <div class="itemPadding col-12 m-0 p-0">
      <button v-if="convenio_funeraria && (!modalSaved || !localData.funeraria.nome)"
              id="btn-add-funeraria"
              class="btn btn-add-funeraria btn-sm btn-outline-primary btn-block m-0 mb-3"
              type="button"
              @click="searchFunerarias()">
        <IconSvg class="icon-add icon--sm mr-1"
                 icon="add" />
        Adicionar funerária
      </button>
    </div>

    <b-modal v-if="showModal"
             modal-class="modalAddFuneraria"
             body-class="modalAddFuneraria_body"
             :hide-header="true"
             :visible="true"
             centered
             size="xl"
             no-close-on-backdrop
             no-close-on-esc
             @ok="modalChanged"
             @hide="verifyReset"
             @show="showModalFuneraria()">
      <div class="row align-items-end">
        <div class="col-sm-9">
          <div class="form-group">
            <label
              class="label"
              for="nomeFuneraria">Nome da Funerária</label>
            <input
              id="nomeFuneraria"
              ref="nomeFuneraria"
              v-model="search"
              class="form-control form-control-sm"
              name="nomeFuneraria"
              placeholder="Funerária São Paulo"
              type="text"
              @keyup.enter="searchFunerarias(),showfuneraria()">
          </div>
          <BoxEndereco
            :no-header="true"
            :data="localData.funeraria.endereco"
            :endereco-disable="false"
            :prop-cartorio="propCartorio"
            @onEnderecoAdd="getFunerariaAddress" />
        </div>

        <div class="col-auto">
          <div class="form-group">
            <button
              class="btn btn-sm btn-primary btnSearch"
              type="button"
              @click="searchFunerarias(),showfuneraria()">
              Pesquisar local
            </button>
          </div>
        </div>
      </div>

      <div class="row mb-2">
        <div v-if="funerarias.length > 0 && showFunerarias"
             class="col">
          <div class="itemPadding">
            Escolha uma das opções. Caso não a encontre, você poderá prosseguir com as informações que estiverem preenchidas.
          </div>

          <div v-for="(funeraria, index) in funerarias"
               :key="`${ _uid }_funeraria_listado_${ index }`"
               class="row">
            <div class="col">
              <span
                :key="funeraria.funeraria_sugestao_id"
                class="custom-control custom-radio">
                <input
                  :id="`local-funeraria_${funeraria.funeraria_sugestao_id}`"
                  v-model="funerariaSelected"
                  :value="funeraria"
                  type="radio"
                  :name="`cemiterioSelecionada_${index}`"
                  class="custom-control-input"
                  @input="selecionaFuneraria(funeraria)"
                  @keyup.enter="selecionaFuneraria(funeraria)">
                <label
                  class="custom-control-label"
                  :for="`local-funeraria_${funeraria.funeraria_sugestao_id}`">
                  {{ funeraria.nome }} - {{ funeraria.endereco | Endereco }}
                </label>
              </span>
            </div>
          </div>

          <div class="itemPadding">
            <Pagination :page="page"
                        :last-page="last_page"
                        @onPreviousPage="changePage(page - 1)"
                        @onNextPage="changePage(page + 1)" />
          </div>
        </div>

        <div v-if="funerarias.length == 0 && showFunerarias"
             class="col">
          <p class="mb-0 itemPadding">
            <small><strong>Nenhum resultado encontrado.</strong>
              <br> Talvez este local não esteja cadastrado ainda no nosso banco de dados ou você esteja sem conexão com a internet.
              <br> Caso este local não esteja cadastrado, ele será cadastrado ao final do preenchimento desse registro.
              <br> </small>
          </p>
        </div>
      </div>

      <div class="row ml-1">
        <div class="form-group mb-0">
          <label
            class="d-block label"
            for="completo">Gostaria de preencher e mostrar na certidão o endereço completo do local?</label>

          <span class="custom-control custom-radio custom-control-inline">
            <input
              id="completo"
              v-model="localData.showEndereco"
              type="radio"
              name="enderecoDisableFunSim"
              :value="true"
              :disabled="!search"
              class="custom-control-input"
              @change="changed">
            <label
              class="custom-control-label"
              for="completo">Sim</label>
          </span>

          <span class="custom-control custom-radio custom-control-inline">
            <input
              id="incompleto"
              v-model="localData.showEndereco"
              type="radio"
              name="enderecoDisableFunNao"
              :value="false"
              :disabled="!search"
              class="custom-control-input"
              @change="changed">
            <label
              class="custom-control-label"
              for="incompleto">Não</label>
          </span>
        </div>
      </div>

      <div class="row ml-1 mt-2">
        <span v-if="!localData.showEndereco">
          A UF e Cidade escolhida acima será utilizada na certidão
        </span>
      </div>

      <div v-if="localData.showEndereco"
           class="row">
        <div class="col">
          <BoxEndereco
            :disabled="!search"
            :no-header="true"
            :data="localData.funeraria.endereco"
            :prop-cartorio="propCartorio"
            @onEnderecoAdd="getFunerariaAddress" />
        </div>
      </div>

      <div slot="modal-footer"
           slot-scope="{ ok, cancel }"
           class="modalAddGenitor_footer">
        <button class="btn btn-sm btn-dark mr-2"
                type="button"
                @click="verifyReset()">
          Voltar
        </button>
        <button v-if=" modalSaved && editItem "
                class="btn btn-sm btn-primary mr-2"
                type="button"
                :disabled="(!funerariaSelected && !search) || (!localData.funeraria.endereco.uf) || (!localData.funeraria.endereco.cidade)"
                @click="verifyChange(), changeEndereco()">
          Editar
        </button>
        <button v-else
                class="btn btn-sm btn-primary mr-2"
                type="button"
                :disabled="(!funerariaSelected && !search) || (!localData.funeraria.endereco.uf) || (!localData.funeraria.endereco.cidade)"
                @click="verifyPermission()">
          Adicionar
        </button>
      </div>
    </b-modal>
    <BoxFuneraria v-if="modalSaved && localData.funeraria.nome"
                  :dados="localData">
      <slot>
        <button type="button"
                class="btn btn-sm btn-danger mr-2"
                @click="removeFuneraria()">
          Excluir
        </button>

        <button class="btn btn-sm btn-primary"
                type="button"
                @click="editFuneraria()">
          Editar
        </button>
      </slot>
    </BoxFuneraria>
  </div>
</template>

<script>
  /* assets */
  import add from "@/assets/icons/add.svg?sprite"

  /* components */
  import BoxEndereco from '@/components/SofiaRei/BoxEndereco.vue'
  import BoxFuneraria from '@/components/SofiaRei/Obito/Passos/Sessoes/BoxFuneraria.vue'
  import Pagination from '../../../Pagination'

  /* services */
  import FunerariaSugestaoService from "@/services/Registros/Obito/FunerariaSugestaoService"
  import FunerariasService from "@/services/Registros/Obito/FunerariasService"
  import ObitoService from "@/services/Registros/Obito"

  /** constants */
  import { CADASTRAR_FUNERARIA, ADMIN } from "@/constants/permissions"

  /* others */
  import {mapGetters} from "vuex"

  export default {
    name: 'Funeraria',
    components: { BoxEndereco, BoxFuneraria, Pagination },
    props: {
      convenioFuneraria: { type: [Boolean], default: (() => 0) },
      disableEndereco: { type: Boolean, default: ()=> false },
      funeraria: { type: Object, default: (() => {}) },
      funerariaId: { type: [String, Number] },
      numeroDeclaracaoFuneraria: { type: String },
      readOnly: { type: Boolean, default: ()=> false},
      propCartorio: { type: Object, default: () => { return {} } }
    },
    data () {
      return {
        add,
        search: '',
        showFunerarias: false,
        showModal: false,
        show_results: true,
        editItem: '',
        modalSaved: this.funeraria.nome ? true : false,
        rascunhoEndereco: {},
        rascunhoNome: '',
        funerariasBusca: [],
        funerariaManual: null,
        funerarias: [],
        aviso: '',
        convenio_funeraria: this.convenioFuneraria,
        funerariaSelected: this.funeraria || null,
        localData: {
          funeraria: {
            endereco: {},
            ativo: true
          },
          numero_declaracao_funeraria: this.numeroDeclaracaoFuneraria,
          showEndereco: this.disableEndereco
        },
        page: 1,
        last_page: 1,
        CADASTRAR_FUNERARIA,
        ADMIN
      }
    },
    computed: {
      ...mapGetters({
        user: 'auth/getUser'
      })
    },
    watch: {
      funerariaId () {
        if (this.funerariaId) {
          this.convenio_funeraria = this.convenioFuneraria
          this.funerariaSelected = this.funeraria || null
          this.localData = {
            funeraria: this.funeraria,
            showEndereco: this.enderecoDisable,
            numero_declaracao_funeraria: this.numeroDeclaracaoFuneraria,
          }
        }
      },
      convenio_funeraria () {
        if (!this.convenio_funeraria && (this.funerariaSelected || this.numeroDeclaracaoFuneraria || this.localData.funeraria.nome)) {

          objSwal.info.title = 'Atualizar Funerária do Registro'
          objSwal.info.confirmButtonText = 'Desvincular Funerária'
          objSwal.info.showCancelButton = true
          objSwal.info.cancelButtonText = 'Não',
          objSwal.info.text = 'Deseja remover a funerária vinculada anteriormente?'

          setTimeout(() => {
            const btnConfirm = document.querySelector('.swal2-confirm')

            if (btnConfirm) btnConfirm.focus()
          }, 300)

          return Swal.fire(objSwal.info).then(async res => {
            return res.dismiss ? this.convenio_funeraria = 1 : this.resetAll()
          })
          if (!this.localData.funeraria.nome) this.lastFuneraria()
        }
      },
      propCartorio () {
        this.init()
      }
    },
    mounted () {
      if (this.funeraria) {
        this.localData.funeraria = this.funeraria
        this.funerariaSelected = this.funeraria.funeraria_id
        this.enderecoDisable = false
        this.modalSaved = true
      }

      this.init ()
    },
    methods: {
      modalChanged () {
        this.showModal = false
        this.show_results = true
        this.funerariaSelected = {}
      },

      showfuneraria () {
        this.showFunerarias = true
      },
      init () {
        if (this.propCartorio && this.propCartorio.endereco) {
          if (Object.values(this.localData.funeraria).length > 2) return

          this.localData.funeraria.endereco = {
            uf: this.propCartorio.endereco.uf,
            cidade: this.propCartorio.endereco.cidade,
            ibge: this.propCartorio.endereco.ibge
          }
        }

        this.changed()
      },
      showModalFuneraria () {
        setTimeout(() => {
          this.$refs.nomeFuneraria.focus()
        }, 50)
      },
      async resetAll () {
        this.funerariaSelected = ''
        this.funerarias = []
        this.localData = { funeraria: {}, numero_declaracao_funeraria: '' }
        this.showModal = false
        this.search = ''
        this.showFunerarias = false
        this.localData.funeraria.endereco = {
          uf: this.propCartorio.endereco.uf,
          cidade: this.propCartorio.endereco.cidade,
          ibge: this.propCartorio.endereco.ibge
        }

        if (!this.readOnly) {
          await ObitoService.updateObito(this.$route.params.id, {
            numero_declaracao_funeraria: '',
            showEndereco: false,
            convenio_funeraria: '0',
            funeraria_id: null,
          }, 0)
        }
        this.changed()
      },

      async changeNumDeclrFun () {
        if (!this.readOnly) {
          await ObitoService.updateObito(this.$route.params.id, { numero_declaracao_funeraria: this.localData.numero_declaracao_funeraria }, 0)
        }
        this.changed()
      },
      async changeEndereco () {
        if (!this.readOnly) {
          await ObitoService.updateObito(this.$route.params.id, { showEndereco: this.localData.showEndereco }, 0)
        }
        this.changed()
      },
      setFunerariaManual () {
        this.localData.funeraria.endereco.uf ? this.localData.funeraria.endereco.uf : this.propCartorio.endereco.uf
        this.localData.funeraria.endereco.cidade ? this.localData.funeraria.endereco.cidade : this.propCartorio.endereco.cidade
        if (!this.localData.funeraria.nome) this.localData.funeraria.nome = this.search
        this.showModal = false
      },

      async searchFunerarias () {
        try {
          loader({ active: true })
          // Limpa a seleção atual
          this.funerariaSelected = null
          this.funerariaManual = null
          this.showModal = true
          this.show_results = true
          this.localData = {
            numero_declaracao_funeraria: this.localData.numero_declaracao_funeraria,
            showEndereco: this.localData.showEndereco,
            funeraria: {
              ativo: true,
              endereco: {
                uf: this.funeraria.endereco && this.funeraria.endereco.uf ? this.funeraria.endereco.uf : this.propCartorio.endereco.uf ,
                cidade: this.funeraria.endereco && this.funeraria.endereco.cidade ? this.funeraria.endereco.cidade :  this.propCartorio.endereco.cidade,
                ibge: this.propCartorio.endereco.ibge ? this.propCartorio.endereco.ibge : null
              }
            },
          }

          if (!this.funerarias.length) {
            this.aviso = true
            this.localData.showEndereco = false
          }

          this.changed()

          const res = await FunerariaSugestaoService.getFunerariaSugestao({
            cartorio_id: this.$store.state.auth.cartorio_id,
            nome: this.search
          })
          this.page = 1
          this.last_page = res.lastPage
          this.funerarias = res.data
          this.funerariasBusca = this.funerarias.filter((funeraria) => (funeraria.endereco.uf == this.localData.funeraria.endereco.uf && funeraria.endereco.cidade == this.localData.funeraria.endereco.cidade))

        } catch (error) {
          console.error(error)
        } finally {
          loader({ active: false })
        }

        this.changed()
      },

      getFunerariaAddress (endereco) {
        this.localData.funeraria.endereco = endereco
        this.localData.funeraria.cartorio_id = this.$store.state.auth.cartorio_id

        this.changed()
      },
      verifyChange () {
        if (!this.funerariaSelected || (this.funerariaSelected || this.modalSaved)) {
          this.setFunerariaManual()
          this.modalSaved = true
          this.changed()
        }
        else {
          this.showModal = false
          this.modalSaved = true
        }
      },
      verifyReset () {
        if (!this.modalSaved) {
          this.resetAll()
        }
        else {
          this.localData.funeraria.endereco.uf = this.rascunhoEndereco.uf
          this.localData.funeraria.endereco.cidade = this.rascunhoEndereco.cidade
          this.localData.funeraria.nome = this.rascunhoNome
          this.showModal = false
        }

      },

      selecionaFuneraria (funeraria) {
        this.funerariaSelected = funeraria
        this.search = funeraria.nome
      },

      changed (val) {
        let funeraria = this.funerariaSelected && this.localData.funeraria ? this.funerariaSelected : this.localData.funeraria

        if (!!this.search && funeraria) {
          funeraria.nome = this.search
        }

        if (this.localData.funeraria) {
          this.localData.funeraria = {
            ...this.localData.funeraria,
            nome: funeraria.nome
          }
        }

        let numero_declaracao_funeraria = this.localData.numero_declaracao_funeraria
        let showEndereco = this.localData.showEndereco
        let convenio_funeraria = this.convenio_funeraria
        let funeraria_id = !!this.localData.funeraria_id ? this.localData.funeraria_id : null

        if (funeraria) {
          funeraria.cartorio_id = parseInt(this.$store.state.auth.cartorio_id)
        }

        if (!this.convenio_funeraria) {
          funeraria = null
          numero_declaracao_funeraria = null
          showEndereco = null
          convenio_funeraria = 0
          funeraria_id = null
        }

        this.$emit('changed', {
          funeraria: funeraria,
          numero_declaracao_funeraria: numero_declaracao_funeraria,
          convenio_funeraria: convenio_funeraria,
          showEndereco: showEndereco,
          funeraria_id: funeraria_id
        })
      },
      removeFuneraria () {
        objSwal.question.title = 'Tem certeza que deseja excluir essa Funeraria ?'
        objSwal.question.text = ''
        objSwal.question.cancelButtonText = 'Não'
        objSwal.question.confirmButtonText = 'Sim'

        setTimeout(() => {
          const btnCancel = document.querySelector('.swal2-cancel')

          if (btnCancel) btnCancel.focus()
        }, 300)

        Swal.fire(objSwal.question).then(async resp => {
          if (resp.value) {
            this.resetAll()
            this.localData.funeraria = null
            this.localData.funeraria_id = null
            this.modalSaved = false

            await this.changed()

            setTimeout(() => {
              const btnAddFuneraria = document.getElementById('btn-add-funeraria')

              if (btnAddFuneraria) btnAddFuneraria.focus()
            }, 300)
          }
        })
      },
      editFuneraria () {
        this.search = this.localData.funeraria.nome
        this.rascunhoNome = this.localData.funeraria.nome
        this.rascunhoEndereco.uf = this.localData.funeraria.endereco.uf
        this.rascunhoEndereco.cidade = this.localData.funeraria.endereco.cidade
        this.editItem = true
        this.showModal = true
      },

      async lastFuneraria () {
        const lastFuneraria = await FunerariasService.getLastFuneraria()

        if (lastFuneraria.funeraria_id) {
          this.localData.funeraria = lastFuneraria
          this.convenio_funeraria = true
          this.enderecoDisable = this.enderecoDisable
          this.funerariaSelected = lastFuneraria.funeraria_id

          this.changed()
        }
      },
      async changePage (page) {
        this.res = await FunerariaSugestaoService.getFunerariaSugestao({
          cartorio_id: this.$store.state.auth.cartorio_id,
          nome: this.search,
          page: page,
          ativo: 1
        })

        this.page = page
        this.last_page = this.res.lastPage
        this.funerarias = this.res.data
        this.funerariasBusca = this.funerarias.filter((funeraria) => (funeraria.endereco.uf == this.localData.funeraria.endereco.uf && funeraria.endereco.cidade == this.localData.funeraria.endereco.cidade))
      },
      verifyPermission () {
        // Verificamos a permissão no método pois nenhuma rota é chamada
        // Se for oficial ou suporte não validamos
        const { groups, flag_oficial } = this.user

        let login = ''

        if (this.user) {
          login = this.user.login.split('_')[0]
        }

        if (groups && groups.length) {
          let access = false
          const permissions = [this.CADASTRAR_FUNERARIA, this.ADMIN]

          groups.forEach(group => {
            const permission = !!group.permissions.find(permission => !!permissions.includes(permission.codename))

            if (permission && group.ativo) access = true
          })

          if (!access && !this.funerariaSelected) {
            return displayMessage('error', 'Acesso negado!', 'Você não tem permissão para realizar essa ação.')
          }
        } else if (login !== 'suporte' && !flag_oficial && !this.funerariaSelected) {
          return displayMessage('error', 'Acesso negado!', 'Você não tem permissão para realizar essa ação.')
        }

        this.verifyChange()
        this.changeEndereco()
      }
    }
  }
</script>

<style lang="scss">
  @import '/../../../../../scss/_utilities/_exports';

    .btnSearch{
    position: relative;
    right: 400px;
    top:-10px;
  }
  .btnAdd{
    border: solid 1px #086aae;
    fill: #074f7f;
    font-size:16px;
    height: 40px;
    color:#074f7f;
  }
  .btnAdd:hover{

    fill:white;
    color:white;
  }
  .itemPadding{
    padding-bottom: 12px;
  }
  .listPadding{
    padding-left:23px ;
  }

  .btn-add-funeraria:hover > [class*=icon-add] {
    fill: #fff !important;
  }
  .icon-add {
    fill: #1c7af5 !important;
    width: 16px;
    height: 16px;
    transition: fill 0.2s;
  }
</style>
